module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("Captain Harry Zucker was a big, broad man with a seamed face and steady gray eyes. He cut a slice of pastrami, scowled at Gray, and said, “Probation, for God’s sake. You’ll never cure that Carroll kid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Want to bet?” Gray asked. He was feeling fine. He himself had been convinced, after an examination of the boy, that he could get to the root of the conflicts that had led to car-theft. And he had been equally convinced that reformatory would probably ruin the boy completely. He hoped that the judge would agree.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Behind bars, they’re safe,” Zucker said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Till they get out”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Ten bucks that if Carroll gets off he’s picked up again within six months.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s a bet. You lost the last one, remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve still got my eye on Brewster. He’ll repeat. He may have already, for all I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s got a good job, and I think he’ll stick to it,” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is he still in analysis?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s tailing off now. He’ll be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zucker grunted. The conversation turned, until Gray managed to steer it to unsolved cases, thence to muggings, and finally to the murder of Eleanor Pope.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I remember that one,” Zucker said. “One of those still unsolved deals where everybody tried to cover up. You know the Pope House restaurants? Well, Pope was the woman’s husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Covering up what?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nothing to do with the murder,” Zucker said. “The Pope woman had been sleeping around. Hell, she was twenty years younger than her husband. Wanted a good time. A real dish, too! You know Carol Webster?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Runs a casino—"), _c('i', [_vm._v("La Noche")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s right. Everything from roulette to horses. Her place is up on Russian Hill. Well, the Pope woman was on her way home from "), _c('i', [_vm._v("La Noche")]), _vm._v(" the night she got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Did she—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” Zucker said. “She lost. Five hundred odd in cash, and she gave Carol Webster an I.O.U. for four hundred. But we checked up. Somebody could have followed Mrs. Pope from "), _c('i', [_vm._v("La Noche")]), _vm._v(", figuring she’d won a wad.” Zucker shrugged his heavy shoulders. “It looks like a plain mugging, but we haven’t closed the case yet. Not by a long shot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That sounds like you’ve got some leads,” Gray said. “Any suspects?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For a moment Zucker was silent, as though glancing through a card-file in his mind. He took a long drink of beer, drew a deep breath, and said, “This is all off the record, Mike.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We had three suspects. Carol Webster was one of them. I know this was a mugging. That labels the killer as a man—ordinarily. Only Carol isn’t ordinary. She acts like a real lady now, when she doesn’t forget, but it’s my guess she grew up with some slum gang where she learned all the dirty tricks. She’s a graduate juvenile delinquent. She’s gangster stuff, for all her looks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray didn’t comment. Zucker drank more beer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Carol’s got a lot of protection behind her,” he said. “There’s big money involved, somewhere. Racket money. And that means…. Do you know a guy named Bruce Oliver?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. What’s his angle?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He plugs holes,” Zucker said briefly. “With a gun. Or anything else that suits. Only we can’t prove it. He beat two homicide raps, and God knows how many minor charges. He’s in on the racket too. Most of the time he hangs out around "), _c('i', [_vm._v("La Noche")]), _vm._v(". You might call him an errand boy. I’d call him a son of a bitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is he a suspect?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zucker nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I said he was an errand boy. He could have made a delivery to Eleanor Pope that night. He was at "), _c('i', [_vm._v("La Noche")]), _vm._v(" then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A delivery? Dope, you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hell, no. I mean murder.” Zucker glanced at his watch. “The only other real suspect is Arnold Farragut. Know him? Well, he’s a hard guy to pin down. No regular job. Works when he feels like it, and doesn’t care what the job is. One month he’ll be painting a mural and the next he’ll be loading cargo on the docks. And in between he’ll be spending his wad as fast as he can. Farragut’s an oddball, all right. He spends too much for what he makes—I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Any motive there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Could be,” Zucker said. “He was at "), _c('i', [_vm._v("La Noche")]), _vm._v(" that night too. And—I can’t prove it—but I figure he’d been sleeping with Eleanor Pope. Might be a jealousy motive, when he found out she was on the town. That’s about the picture. Carol Webster—a female gangster. Bruce Oliver—a killer. Arnold Farragut—an oddball.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Where was Eleanor Pope killed?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not far from "), _c('i', [_vm._v("La Noche")]), _vm._v(". Down the hill a ways. There’s a little park there, and somebody must have jumped her and dragged her into the park. It wasn’t past midnight, but it was foggy as hell. She was slugged from behind with a rock. Killed her instantly. I wasn’t on the case myself; Fishbein handled it. He said everybody concerned was scared to death of publicity.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Who’s everybody?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, the husband, mostly. Is he a patient of yours?” Zucker didn’t wait for an answer. “Okay, I know you won’t tell me. But did you ever try to psychoanalyze a bulldozer?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What was Pope afraid of?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I told you his wife was sleeping around. He didn’t want that to get in the papers. Why? Have you run across something?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, I’m just curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah?” Zucker said skeptically.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray decided not to ask any more questions.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42141973","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/10_chapter06.vue
// module id = 90
// module chunks = 0